import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'

export interface IExpenseCodeItem {
  id: number;
  code: string;
  name: string;
  description?: string;
}

export interface IExpenseCodeListParams {
  keyword?: string;
  pageNo?: number;
  pageSize?: number;
}

export interface IExpenseCodeListRes {
  pageNo: number;
  pageSize: number;
  totalCount: number;
  result: IExpenseCodeItem[];
}

/** 获取费用代码列表（支持关键字搜索和分页） */
export const fetchExpenseCodeList = async (params?: IExpenseCodeListParams) => {
  const data = await request.get<IExpenseCodeListRes>(
    `${HOSTS.BASE}/api/entweb/expenseCode/list`,
    { params }
  )
  return { success: true, data }
}

export interface IExpenseCodeCreateItem {
  code: string;
  description?: string;
}

export interface IExpenseCodeConflictItem {
  code: string;
  existingId: number;
}

export interface IExpenseCodeCreateRes {
  conflictList?: IExpenseCodeConflictItem[];
}

/** 批量创建费用代码（单次最多 50 条）
 * 返回 conflictList 表示与已有数据冲突的条目，需前端提示
 */
export const createExpenseCode = async (params: {
  expenseCodeCreateList: IExpenseCodeCreateItem[];
}) => {
  const data = await request.post<IExpenseCodeCreateRes>(
    `${HOSTS.BASE}/api/entweb/expenseCode/create`,
    params
  )
  return data
}

export const updateExpenseCode = async (params: {
  id: number;
  code: string;
  description?: string;
}) => {
  await request.post<void>(
    `${HOSTS.BASE}/api/entweb/expenseCode/update`,
    params
  )
}

export const deleteExpenseCode = async (params: { id: number }) => {
  await request.post<void>(
    `${HOSTS.BASE}/api/entweb/expenseCode/delete`,
    params
  )
}
